/**
 * @public
 */
export function hasBox(predicate = () => true, device) {
    return (node) => node.getBoundingBox(device).some(predicate);
}
//# sourceMappingURL=has-box.js.map